import React, { useMemo } from 'react';

import { Button } from '@motorway/mw-highway-code';

import { WordpressData } from '../../../@types/Wordpress';

import { AUTHOR_SOCIAL_ICONS } from './AuthorProfileSection.consts';

import styles from './AuthorProfileSection.module.scss';

export type AuthorProfileSectionProps = {
  author?: WordpressData['author'];
  content: string | null;
  title: string;
};

export const AuthorProfileSection: React.FC<AuthorProfileSectionProps> = ({
  author,
  content,
  title,
}) => {
  const { jobTitle, socialLinks = [], thumbnail } = author || {};

  const links = useMemo(() => socialLinks.map((link) => {
    const socialSite = AUTHOR_SOCIAL_ICONS.find((s) => link.includes(s.domain));
    if (!socialSite) {
      return null;
    }

    return (
      <li key={link} className={styles.socialIcon}>
        <Button
          as="a"
          href={link}
          icon={socialSite.Icon}
          label={socialSite.title}
          rel="noreferrer"
          showLabel={false}
          target="_blank"
        />
      </li>
    );
  }).filter(Boolean), [socialLinks]);

  return (
    <>
      <section className={styles.authorProfile}>
        {thumbnail && (
          <img
            alt={title}
            className={styles.authorThumbnail}
            src={thumbnail}
          />
        )}

        <section className={styles.authorDetails}>
          <h2 className={styles.authorName}>{title}</h2>

          {jobTitle && (
            <p data-thc-style-override className={styles.jobTitle}>{jobTitle}</p>
          )}

          {links.length > 0 && (
            <ul className={styles.socialIcons}>
              {links}
            </ul>
          )}
        </section>
      </section>

      {content && (
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className={styles.authorBio}
        />
      )}
    </>
  );
};
